import { ReactElement, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './error-information-visid.module.scss';

export default function SplunkSessionId(): ReactElement {
  const { t } = useTranslation('common', { keyPrefix: 'errorScreen' });
  const [sessionId, setSessionId] = useState(undefined);
  const splunkRum =
    typeof window !== 'undefined' ? window?.SplunkRum : undefined;

  useEffect(() => {
    setSessionId(splunkRum?.getSessionId());
  }, [splunkRum]);

  return (
    sessionId && (
      <div
        key={`session-id-${sessionId}`}
        data-testid={sessionId}
        className={styles['session-id']}
      >
        <p>
          {t('session')}
          {sessionId}
        </p>
      </div>
    )
  );
}
